<div class="kt-header__brand kt-grid__item" id="kt_header_brand">
  <div class="kt-header__brand-logo">
    <a routerLink="/" target="_blank">
      @if (!appSession.tenant || !appSession.tenant.HasLogo()) {
        <img [src]="defaultLogo" alt="logo" height="38" />
      }
      @if (appSession.tenant && appSession.tenant.HasLogo()) {
<img [src]="remoteServiceBaseUrl + '/TenantCustomization/GetTenantLogo?skin=' + currentTheme.baseSettings.menu.asideSkin + '&tenantId=' + appSession.tenant.id + '&id=' + appSession.tenant.HasLogo()" alt="logo" height="38" />
}
        </a>
    </div>
</div>
